import {ChangeDetectionStrategy, Component, Inject, Input, OnInit,} from "@angular/core";
import {AgentModel} from "../../models/agent.model";
import * as _ from "lodash";
import * as angular from "angular";

require('./agent-avatar.scss');
@Component({
  standalone: false,
  selector: 'app-agent-avatar',
  templateUrl: './agent-avatar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentAvatarComponent implements OnInit {

  @Input() agent: AgentModel;
  @Input() agentReference: any;
  @Input() hideStatus: boolean;
  @Input() hideTaskCount: boolean;
  @Input() size: 'xsmall' | 'small' | 'medium' | 'large' = 'medium';
  @Input() doUpload: boolean;

  constructor(@Inject('agentsService') private agentsService) {
  }

  ngOnInit() {
    if (_.isUndefined(this.doUpload)) {
      this.doUpload = false;
    }
  }

  onUpload(result) {
    const url = _.get(result, 'data.url');
    const agentToUpdate = angular.copy(this.agent);
    _.set(agentToUpdate, 'user.avatarUrl', url);

    this.agentsService.updateOne(this.agent.id, agentToUpdate)
      .then(() => {

      })
  }
}
